<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import camelcaseKeys from 'camelcase-keys';

import { useMapGetter } from 'dashboard/composables/store';
import { frontendURL } from 'dashboard/helper/URLHelper';
import VisitaAPI from 'dashboard/api/visitas';

const REQUESTED_FIELDS = Object.freeze([
  'ACTOR_DETAILS',
  'FOLLOW_UP',
  'HOUSE_DETAILS',
  'STRUCTURED_STATUS',
  'TEMP_MIGRATION_SUPPORT',
  'STATUS_LOG',
]);

const route = useRoute();
const router = useRouter();
const accountId = useMapGetter('getCurrentAccountId');

const hasError = ref(false);
const visitCode = computed(() => String(route.params.visitCode || ''));
const REDIRECT_COPY = Object.freeze({
  loading: 'Abrindo detalhes da visita...',
});

const extraQueryParams = () => {
  const params = new URLSearchParams();

  ['backTo', 'origin'].forEach(key => {
    if (route.query[key]) params.set(key, route.query[key]);
  });

  if (route.name === 'visita_deep_link_finish') {
    params.set('openFinishVisit', 'true');
    if (route.params.result) {
      params.set('finishVisitResult', route.params.result);
    }
  }

  if (route.name === 'visita_deep_link_cancel') {
    params.set('openCancelVisit', 'true');
  }

  if (route.name === 'visita_deep_link_reschedule') {
    params.set('openRescheduleVisit', 'true');
  }

  return params;
};

const redirectToAgenda = () => {
  const params = new URLSearchParams({ visitCode: visitCode.value });
  router.replace(
    frontendURL(`accounts/${accountId.value}/visitas?${params.toString()}`)
  );
};

const redirect = async () => {
  try {
    const { data } = await VisitaAPI.getVisitByCode({
      requestedFields: REQUESTED_FIELDS,
      visitCode: visitCode.value,
    });
    const record = camelcaseKeys(data.payload || data, { deep: true });
    const id = record.id || record.visitId || record.visit_id;
    if (!id) throw new Error('missing visit id');

    const params = extraQueryParams();
    const suffix = params.toString() ? `?${params.toString()}` : '';
    router.replace(
      frontendURL(`accounts/${accountId.value}/visitas/${id}${suffix}`)
    );
  } catch {
    hasError.value = true;
    redirectToAgenda();
  }
};

onMounted(redirect);
</script>

<template>
  <main
    class="grid min-h-screen place-items-center bg-lais-bg-page px-4 py-10 text-center font-redHatText"
  >
    <div v-if="!hasError" class="grid justify-items-center gap-3">
      <span
        class="i-lucide-loader-2 size-8 animate-spin text-lais-primary"
        aria-hidden="true"
      />
      <p class="text-[14px] font-semibold text-lais-text">
        {{ REDIRECT_COPY.loading }}
      </p>
    </div>
  </main>
</template>
